

<template>
    <div>
        <div>
            <el-button type="primary" @click="setMainTribe">主联盟配置</el-button>
            <div class="common-search">
                <el-input
                        v-model="searchVal"
                        class="common-el-input"
                        placeholder="输入联盟昵称或ID查询">
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
                <el-button type="primary" @click="searchUnionList()">搜索</el-button>
            </div>
        </div>
        <div>
            <strong class="common-text-item" v-text="`联盟总数：${unionListTotal}`"></strong>
        </div>
        <div class="common-table">
            <el-table
                    ref="unionTable"
                    v-loading="loading"
                    :data="unionList"
                    row-key="id"
                    height="100%"
                    @row-click="rowClick"
                    @selection-change="selectChange">
                <el-table-column type="selection" width="55"/>
                <el-table-column label="编号" type="index" align="center"/>
                <el-table-column label="用户ID" width="120" align="center" prop="creatorId"/>
                <el-table-column label="用户昵称" min-width="150" align="center" prop="creatorName"/>
                <el-table-column label="联盟昵称" min-width="150" align="center" prop="tribeName"/>
                <el-table-column label="联盟ID" align="center" prop="randomId"/>
                <el-table-column label="俱乐部数量" width="120" align="center">
                    <template slot-scope="scope">{{scope.row.clubMumbers}}/{{scope.row.upperLimit}}</template>
                </el-table-column>
                <el-table-column label="主联盟" min-width="150" align="center" prop="mainTribeName"/>
                <el-table-column label="是否主联盟" align="center" width="150">
                    <div slot-scope="scope" @click.stop="">
                        <el-switch
                                :value="scope.row.ismain"
                                @change="mainTribeChange($event,scope.row)"
                                :active-value="1"
                                :inactive-value="0"
                                active-text="是"
                                inactive-text="否"/>
                    </div>
                </el-table-column>
                <el-table-column label="占成" align="center" width="150">
                    <template slot-scope="scope">
                        <input-set-value
                                size="small"
                                :default-value="scope.row.profit"
                                unit="%"
                                type="number"
                                @my-submit="updateUnionpProfit($event,scope.row.id)"/>
                    </template>
                </el-table-column>
                <el-table-column label="联系方式" width="150" align="center" prop="contact"/>
              <el-table-column label="对赌基金仓" min-width="120" align="center" prop="fund">
                <template slot-scope="scope">{{scope.row.chip | numberChip}}</template>
              </el-table-column>
              <el-table-column label="对赌设置" align="center">
                <template slot-scope="scope">{{scope.row.recordRabtio}}%
                  <i class="el-icon-edit-outline" @click.stop="setClubConfigFunc(scope.row)"></i></template>
              </el-table-column>
              <el-table-column label="是否开启" align="center" width="150">
                <template slot-scope="scope">{{scope.row.open?'开启':'关闭'}}</template>
              </el-table-column>
              <el-table-column label="是否兜底" align="center" >
                <template slot-scope="scope">{{scope.row.contract?'是':'否'}}
                </template>
              </el-table-column>
              <el-table-column label="是否爆仓" align="center" >
                <template slot-scope="scope">{{scope.row.burstStatus?'是':'否'}}
                </template>
              </el-table-column>
                <el-table-column label="创建时间" width="150" align="center" prop="createTime"/>
            </el-table>
        </div>

        <el-pagination
                class="common-el-pagination"
                layout="prev,pager,next,jumper"
                background
                :page-size="20"
                :pager-count="5"
                :total="unionListTotal"
                :current-page="currentPage"
                @current-change="searchUnionList({page:$event})"/>

        <div v-show="show" class="common-popup-bg">
            <div class="common-popup">
                <h3>主联盟配置</h3>
                <el-form
                        ref="rulesForm"
                        label-width="85px"
                        size="medium"
                        :model="form"
                        :rules="rules"
                        class="common-popup-table">
                    <el-form-item label="主联盟：" prop="mainTribeId">
                        <el-select
                                v-model="form.mainTribeId"
                                filterable>
                            <el-option
                                    v-for="item of mainTribeList.beanList"
                                    :key="item.mainTribeId"
                                    :label="item.mainTribeName"
                                    :value="item.mainTribeId"/>
                        </el-select>
                    </el-form-item>
                </el-form>
                <footer>
                    <el-button size="small" @click="close('rulesForm')">取消</el-button>
                    <el-button size="small" type="primary" @click="submitFunc('rulesForm')">确认</el-button>
                </footer>
            </div>
        </div>
      <comp-rebate-config ref="rebate" :info="configInfo" @my-submit="searchUnionList()" />
    </div>
</template>
<script>
    import {mapState, mapMutations, mapActions} from 'vuex'
    import inputSetValue from 'components/inputSetValue'
    import compRebateConfig from "./compRebateConfig";

    export default {
        components: {
            compRebateConfig,
            inputSetValue,
        },
        data() {
            return {
                show: false,
                loading: false,
                searchVal: null,
                currentPage: 1,
                selections: [],
                configInfo:{},
                form: {
                    mainTribeId: ''
                },
                rules: {
                    mainTribeId: [
                        {required: true, message: '请选择主联盟', trigger: 'blur'}
                    ]
                }
            }
        },
        computed: {
            ...mapState('union', ['unionList', 'unionListTotal', 'mainTribeList'])
        },
        created() {
            this.searchUnionList();
        },
        methods: {
            ...mapMutations('union', ['setStateUnionListParams']),
            ...mapActions('union', ['getUnionList', 'updateUnionConfig', 'getMainTribeList', 'updateIsMainStatus', 'updateMainTribe']),
            // 获取联盟列表
            searchUnionList(obj = {}) {
                this.loading = true;
                let params = {
                    content: this.searchVal,
                    page: 1
                };
                Object.assign(params, obj);
                this.currentPage = params.page;
                this.getUnionList(params).then(() => {
                    this.loading = false;
                });
            },
            // 修改是否主联盟
            mainTribeChange(value, row) {
                this.updateIsMainStatus({
                    op: value,
                    tribeId: row.id
                }).then(() => {
                    this.searchUnionList({page: this.currentPage});
                    this.$message.success('请求成功')
                })
            },
            selectChange(rows) {
                rows.forEach(row => {
                    // 如果是主联盟，取消选中
                    if (row.ismain) {
                        this.$refs.unionTable.toggleRowSelection(row)
                    }
                });
                this.selections = rows;
            },
            // 显示设置主联盟窗口
            setMainTribe() {
                this.getMainTribeList().then(()=>{
                    if (!this.mainTribeList.total) {
                        this.$message.error('请先设立主联盟组');
                        return
                    }
                    if (!this.selections.length) {
                        this.$message.error('请选择要配置的联盟');
                        return
                    }
                    this.show = true
                })
            },
            // 设置主联盟
            submitFunc(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        this.updateMainTribe({
                            mainTribeId: this.form.mainTribeId,
                            subTribeIdList: this.selections.map(item=>item.id)
                        }).then(() => {
                            this.$message.success('设置成功');
                            this.searchUnionList({page: this.currentPage});
                            this.close(formName)
                        })
                    }
                })
            },
            close(formName) {
                this.$refs[formName].resetFields();
                this.show = false;
            },
            // 修改联盟占成
            updateUnionpProfit({value, cb}, unionId) {
                this.updateUnionConfig({
                    unionId: unionId,
                    profit: value
                }).then(() => {
                    this.$message.success('修改成功');
                    this.searchUnionList({page: this.currentPage});
                    cb()
                })
            },
          // 联盟对赌配置
          setClubConfigFunc(row){
            this.configInfo = row;
            this.$refs.rebate.show = true;
          },
            rowClick(row) {
                this.$router.push({name: 'unionDetail', params: {id: row.id}})
            }
        }
    }
</script>

